import React, { useState, useEffect } from 'react';
import styles from "./styles.module.css";
import Header from '../../header'
import api_instagram from '../../../../../services/api_instagram'
import Galery from '..'
var imagens = [];

const Diversos: React.FC = (props) => {

    const [bolos, setBolos] = useState(
        [
            {
                media_url: "",
                permalink: "",
            },

        ]
    );

    function pegarSomenteBolos(novosbolo) {
        var somentebolos = [];
        
        novosbolo.forEach(element => {
            if (element.media_type === "IMAGE") {
                if (element.caption) {
                    var captions = element.caption.split(" ", 10);
                    captions.forEach((caption) => {
                        if (caption === '#diversos') {
                            somentebolos = somentebolos.concat(element);
                        }
                    })
                }
            }
        })
        return somentebolos;
    }

    useEffect(() => {
        async function getFotos(uri) {
            console.log(imagens, imagens.length);
            if (uri === '') {
                uri = `me/media?fields=id,caption,media_url,media_type,permalink&access_token=${process.env.REACT_APP_API_INSTAGRAM_TOKEN}`;
            }
            await api_instagram.get(uri)
                .then(function (res) {
                    if (res.data) {
                        imagens = imagens.concat(res.data.data);
                        if (res.data.paging.next) {
                            getFotos(res.data.paging.next);
                        } else {
                            setBolos(pegarSomenteBolos(imagens));
                        }
                    }
                })
                .catch(function (res) {

                })
        }
        if (imagens.length > 0) {
            setBolos(pegarSomenteBolos(imagens));
        } else {
            getFotos('');
        } 
    }, [])

    return (
        <div>
            <div className={styles.containermenu}>
                <Header />
            </div>
            <h1>GALERIA DE GULOSEIMAS DIVERSAS NANDA CONFEITOS</h1>
            <Galery bolos={bolos}/>
        </div>

    )

}


export default Diversos;